import React from 'react'
import Modal from 'react-modal';
import { useModal } from '../../hooks/modal';
import './styles.css'


const customStyles = {
  content: {
    top: '50%',
    border: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: 'rgba(0, 0, 0, 0)',
    width: '100%',
    height: '100%',
  },
  overlay: {
    overflow: 'auto',
    transition: '(top 0.4s, opacity 0.4s)',
    zIndex: 100000,
    background: 'rgba(0, 0, 0, 0.4)',
  }
};

const DisconnectedModal = () => {
  const { disconnectedModalVisible, setDisconnectedModalVisible, setIgnoreQr, toggleReconnect } = useModal();

  return (
    <Modal
      isOpen={disconnectedModalVisible}
      onRequestClose={() => setDisconnectedModalVisible(false)}
      style={customStyles}
      ariaHideApp={false}
      shouldCloseOnOverlayClick
    >
      <div className="loading-modal-container">
        <div className="loading-modal-center">
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
            <div>O Whatsapp QrCode foi desconectado. Escolha uma ação: </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row', marginTop: 20 }}>
              <button className="loading-modal-return-button" onClick={() => {toggleReconnect();setDisconnectedModalVisible(false)}}>Reconectar !</button>
              <button className="loading-modal-return-button" onClick={() => {setIgnoreQr(true); setDisconnectedModalVisible(false)}}>Ignorar !</button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default DisconnectedModal;
